<template>
  <div
    class="container-fluid"
    infinite-scroll-immediate="false"
    infinite-scroll-disabled="disabled"
    v-infinite-scroll="getInterviewRecordResult"
  >
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <div class="card search-card">
      <div class="card-body">
        <ValidationObserver v-slot="{ handleSubmit }">
          <div class="form-row">
            <!-- 面談日期 -->
            <div class="col-sm-12 col-md-4">
              <div class="form-group">
                <ValidationProvider
                  :rules="{ dateRangeRequired: true }"
                  v-slot="{ errors }"
                >
                  <label for="">面談日期</label>
                  <el-date-picker
                    class="w-100"
                    type="daterange"
                    :clearable="false"
                    :picker-options="{
                      disabledDate: $common.disabledDateAfterToday,
                    }"
                    v-model="searchCondition.interviewDateRange"
                  />
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>

            <!-- 職缺名稱 -->
            <div class="col-sm-12 col-md-4">
              <div class="form-group">
                <label for="">職缺名稱</label>
                <el-input
                  clearable
                  maxlength="50"
                  placeholder="請輸入關鍵字"
                  v-model.trim="searchCondition.ManpowerDemandName"
                />
              </div>
            </div>

            <div class="col-sm-12 col-md-4">
              <div class="form-group">
                <label for="">應聘者</label>
                <el-input
                  clearable
                  maxlength="50"
                  placeholder="請輸入關鍵字"
                  v-model.trim="searchCondition.Name"
                />
              </div>
            </div>

            <!-- 面談紀錄 -->
            <div class="col-sm-12 col-md-4">
              <div class="form-group">
                <label for="">面談紀錄</label>
                <el-select
                  class="w-100"
                  placeholder="請選擇"
                  v-model="searchCondition.IsWrote"
                >
                  <el-option label="不拘" :value="null"></el-option>
                  <el-option label="已填寫" :value="true"></el-option>
                  <el-option label="未填寫" :value="false"></el-option>
                </el-select>
              </div>
            </div>

            <div class="col-sm-12 col-md-4">
              <button
                type="button"
                id="search"
                class="btn btn-primary btn-search"
                style="margin-top: 30px; margin-left: 10px"
                @click="
                  (currentPage = 1),
                    (personList = []),
                    (totalPerson = 0),
                    handleSubmit(getInterviewRecordResult)
                "
              >
                {{ i18n("Buttons.Search") }}
              </button>

              <button
                type="button"
                class="btn btn-secondary"
                style="margin-top: 30px; margin-left: 10px"
                @click="
                  searchCondition = {
                    interviewDateRange: [
                      new Date($common.getLastMonth()),
                      new Date($common.getToday()),
                    ],
                    IsWrote: false,
                  }
                "
              >
                清除
              </button>
            </div>
          </div>
        </ValidationObserver>
      </div>
    </div>

    <!-- 卡片顯示樣式 -->
    <div class="tool-list" v-if="personList.length > 0">
      <div class="tool-list-about-card">
        <span
          @click="gridStyle = 'block'"
          :class="{ active: gridStyle == 'block' }"
        >
          <eva-icon fill="#000" name="grid-outline" />
        </span>
        <span
          @click="gridStyle = 'list'"
          :class="{ active: gridStyle == 'list' }"
        >
          <eva-icon fill="#000" name="list-outline" />
        </span>
      </div>
    </div>

    <!-- 卡片列表 -->
    <div
      class="person-card-list"
      :class="{
        'list-style': gridStyle == 'list',
        'block-style': gridStyle == 'block',
      }"
    >
      <div
        class="person-card"
        v-for="(person, index) in personList"
        :key="index"
      >
        <PersonCard ref="personCard" :showCheckbox="false" :person="person">
          <template v-slot:tag="{ props }">
            <div class="result">
              {{
                props.InterviewResult === null ? "待定" : props.InterviewResult
              }}
            </div>
          </template>

          <template v-slot:middleContent="{ props }">
            <table>
              <tr>
                <th>職缺名稱</th>
                <td>{{ props.ManpowerDemandName }}</td>
              </tr>
              <tr>
                <th>面談時間</th>
                <td>{{ $common.dateFormatter(props.InterviewDate) }}</td>
              </tr>
              <tr>
                <th>面談地點</th>
                <td>{{ props.InterviewPlace }}</td>
              </tr>
              <tr style="height: 90px">
                <th>學歷</th>
                <td>{{ props.Education ? props.Education[0] : null }}</td>
              </tr>
              <tr>
                <th>經歷</th>
                <td>
                  {{ props.WorkExperience ? props.WorkExperience[0] : null }}
                </td>
              </tr>
            </table>
          </template>

          <template v-slot:buttonGroup="{ props }">
            <button type="button" @click="showDetailModal(props)">
              檢視資訊
            </button>
            <button
              v-if="$Permission.InterviewHistory.WriteScore.IsValid"
              type="button"
              @click="writeScore(props)"
            >
              輸入成績
            </button>
            <el-dropdown>
              <button type="button" class="el-dropdown-link">
                面談紀錄<i class="el-icon-arrow-down el-icon--right"></i>
              </button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="createInterviewRecord(props)">
                  填寫面談紀錄
                </el-dropdown-item>
                <el-dropdown-item
                  @click.native="getInterviewRecordHistory(props.MatchId)"
                >
                  面談紀錄歷程
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </PersonCard>
      </div>
    </div>

    <!-- 面談紀錄歷程 Modal -->
    <div
      class="modal fade"
      id="interviewRecordHistoryModal"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <span>面談紀錄歷程</span>
          </div>
          <div class="modal-body">
            <ValidationObserver v-slot="{ handleSubmit }">
              <div class="d-flex align-items-start" style="margin-bottom: 10px">
                <ValidationProvider
                  ref="addInterviewSupervisor"
                  class="w-100"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <el-select
                    class="w-100"
                    multiple
                    filterable
                    placeholder="請選擇加簽人員"
                    v-model="InterviewSupervisor"
                  >
                    <el-option
                      v-for="(supervisor, index) in supervisorOptions"
                      :key="index"
                      :label="supervisor.Name"
                      :value="supervisor.Guid"
                    >
                    </el-option>
                  </el-select>
                  <p class="text-danger">{{ errors[0] }}</p>
                </ValidationProvider>
                <button
                  class="btn btn-primary"
                  style="margin: 2px 0 0 10px; width: 70px"
                  @click="handleSubmit(addInterviewRecord)"
                >
                  加簽
                </button>
              </div>
            </ValidationObserver>
            <div class="evaluation-person-info">
              <div>
                <label for="">姓名</label>
                <div>{{ recordList.Interviewee }}</div>
              </div>

              <div>
                <label for="">面談日期</label>
                <div
                  v-for="(date, index) in recordList.InterviewDateList"
                  :key="index"
                >
                  {{ $common.dateTimeFormatter(date) }}
                </div>
              </div>

              <div v-for="score in recordList.Scores" :key="score.Seq">
                <label for="">{{ score.Name }}</label>
                <div>{{ score.Score }}</div>
              </div>

              <span
                style="
                  position: absolute;
                  right: 5px;
                  bottom: 2px;
                  color: #ffffff;
                  z-index: 2;
                  font-size: 0.9em;
                "
              >
                最後更新者：{{ recordList.UpdateUser }}
              </span>
            </div>

            <template
              v-if="
                recordList.InterviewRecords &&
                recordList.InterviewRecords.length > 0
              "
            >
              <div style="display: flex; margin-top: 2px">
                <div class="evaluation-body fixed">
                  <div
                    class="evaluation-name"
                    style="height: 60px; line-height: 50px"
                  >
                    面談主管
                  </div>
                  <div
                    v-for="item in recordList.InterviewRecords[0]
                      .InterviewRecordAppraisals"
                    :key="item.Name"
                    class="evaluation-field"
                  >
                    {{ item.Name }}
                  </div>

                  <template v-if="recordList.ResumeType === 'IDL'">
                    <div class="evaluation-field">職等</div>
                  </template>

                  <div
                    class="evaluation-field"
                    style="height: 150px; overflow-y: auto"
                  >
                    面談說明
                  </div>

                  <div
                    class="evaluation-field"
                    style="height: 150px; overflow-y: auto"
                  >
                    個人備註
                  </div>
                  <div class="evaluation-field">面談結果</div>

                  <div class="evaluation-field" style="height: 42px" />
                </div>

                <div style="flex: 1; min-width: 1px">
                  <carousel
                    :items="recordList.InterviewRecords.length"
                    :nav="true"
                    :dots="false"
                  >
                    <div
                      v-for="record in recordList.InterviewRecords"
                      class="evaluation-body"
                      :key="record.InterviewSupervisorId"
                      @dblclick="$common.copyText($event)"
                    >
                      <div class="evaluation-name" style="height: 60px">
                        【{{ record.InterviewTitle }}】<br />
                        <el-tooltip
                          class="item"
                          effect="dark"
                          :content="record.InterviewSupervisor+' ('+record.InterviewUserType+')'"
                          placement="right"
                        >
                          <span>
                            {{ record.InterviewSupervisor }} ({{
                              record.InterviewUserType
                            }})
                          </span>
                        </el-tooltip>
                      </div>

                      <div
                        v-for="item in record.InterviewRecordAppraisals"
                        class="evaluation-field"
                        :key="item.Name"
                      >
                        <template
                          v-if="item.Result !== '-' && item.Result !== '未填寫'"
                        >
                          <el-tooltip
                            v-if="item.Remark"
                            class="item"
                            effect="dark"
                            :content="item.Remark"
                            placement="right"
                          >
                            <span>
                              {{ item.Result }}
                            </span>
                          </el-tooltip>
                          <span v-else>{{ item.Result }}</span>
                        </template>
                        <span v-else>{{ item.Result }}</span>
                      </div>

                      <template v-if="recordList.ResumeType === 'IDL'">
                        <!-- 職等 -->
                        <div class="evaluation-field">
                          {{ record.ExpectedJobLevel }}
                        </div>
                      </template>

                      <!-- 面談備註 -->
                      <div
                        class="evaluation-field"
                        style="height: 150px; overflow-y: auto"
                      >
                        <div>
                          {{ record.Remark }}
                        </div>
                      </div>
                      <!-- 個人備註 -->
                      <div
                        class="evaluation-field"
                        style="height: 150px; overflow-y: auto"
                      >
                        <div>
                          {{ record.PersonalRemark }}
                        </div>
                      </div>
                      <!-- 面談結果 -->
                      <div class="evaluation-field">
                        <div>
                          {{ record.InterviewResult }}
                        </div>
                      </div>

                      <div class="evaluation-field" style="height: 42px">
                        <button
                          v-if="record.InterviewResult === '未填寫'"
                          class="btn btn-warning btn-sm"
                          @click="
                            interviewRecordUrge(record.InterviewSupervisorId)
                          "
                        >
                          催辦
                        </button>
                        <div v-else>已填寫面談紀錄</div>
                      </div>
                    </div>
                  </carousel>
                </div>
              </div>
            </template>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              關閉
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 輸入成績 -->
    <div
      class="modal fade"
      id="scoreModal"
      data-focus="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <ValidationObserver
          ref="scoreModal"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <form
            @submit.prevent="handleSubmit(saveCommonModal)"
            @reset.prevent="reset"
          >
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">輸入成績</h5>
              </div>
              <div class="modal-body">
                <el-table :data="candidateScores" border style="width: 100%">
                  <el-table-column
                    fixed
                    label="姓名"
                    height="250"
                    min-width="20%"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.Name }}/{{
                        scope.row.IsForeigner ? "外籍" : "本籍"
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-for="score in scoreType[0]"
                    :key="score.Seq"
                    :label="score.Name"
                    height="250"
                    align="center"
                    min-width="40%"
                  >
                    <template slot-scope="scope">
                      <span v-for="item in scope.row.Scores" :key="item.Seq">
                        <input
                          type="number"
                          v-if="item.HasOriginScore && item.Name === score.Name"
                          class="form-control text-center"
                          style="background-color: #dedede"
                          disabled
                          v-model="item.OriginScore"
                        />
                        <template v-if="item.Name === score.Name">
                          <ValidationProvider
                            class="w-100"
                            :name="scope.row.Name + score.Name"
                            :rules="{
                              min_value: item.ScoreLowest,
                              max_value: item.ScoreHighest,
                            }"
                            v-slot="{ errors }"
                          >
                            <input
                              type="text"
                              class="form-control text-center"
                              :style="{
                                backgroundColor: !item.CanWrite
                                  ? '#dedede'
                                  : '#ffffff',
                              }"
                              :disabled="!item.CanWrite"
                              v-model="item.Score"
                            />
                            <span v-if="errors[0]" class="text-danger">
                              {{ errors[0] }}
                            </span>
                          </ValidationProvider>
                        </template>
                      </span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="modal-footer">
                <button
                  type="reset"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  {{ i18n("Buttons.Cancel") }}
                </button>
                <button type="submit" class="btn btn-primary">
                  {{ i18n("Buttons.Save") }}
                </button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- 各資訊總覽 -->
    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceInLeft"
      leave-active-class="animated bounceOutRight"
    >
      <div class="detail-modal" v-if="isShowDetail">
        <div class="detail-modal-inner">
          <div class="menu">
            <a @click.prevent="detailCurrentPage = 0">
              <span>
                <eva-icon name="person-outline" fill="#FFF"></eva-icon>
                履歷
              </span>
            </a>
            <div
              class="close-show-detail"
              @click="isShowDetail = !isShowDetail"
            >
              <eva-icon
                name="close-circle"
                fill="#FFF"
                width="50"
                height="50"
              ></eva-icon>
            </div>
          </div>
          <div class="page-wrap">
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 0" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">履歷</div>
                    <div class="item text-right">
                      <button
                        v-if="ResumeSource === '應聘者填寫'"
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        @click="$common.downloadResumePDF(ResumeType, ResumeId)"
                      >
                        下載 PDF
                      </button>
                    </div>
                  </div>
                  <template v-if="ResumeSource === '應聘者填寫'">
                    <IdlResume
                      v-if="ResumeType === 'IDL'"
                      :ResumeId="ResumeId"
                      :ResumeType="ResumeType"
                    />
                    <DlResume
                      v-if="ResumeType === 'DL'"
                      :ResumeId="ResumeId"
                      :ResumeType="ResumeType"
                    />
                  </template>
                </section>
              </perfect-scrollbar>
            </transition>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
import carousel from "vue-owl-carousel2";
// 公司LOGO
import Logo from "@/components/company/Logo.vue";
// 人員卡片
import PersonCard from "@/components/back/Card/Person";
// 履歷(DL/IDL)
import IdlResume from "@/components/customize/Back/IdlResume";
import DlResume from "@/components/customize/Back/DlResume";

export default {
  name: "InterviewHistory",

  components: {
    Logo,
    carousel,
    PersonCard,
    IdlResume,
    DlResume,
  },
  data() {
    return {
      // 卡片顯示樣式 有 block / list 兩種
      gridStyle: "block",

      // data
      personList: [],

      // 查詢
      searchCondition: {
        interviewDateRange: [],
        IsWrote: false,
      },

      // 批次輸入成績
      manpowerDemandNo: "",
      scoreType: [], // 成績類型
      candidateScores: [], // 應聘者成績

      // 檢視資訊
      MatchId: null,
      ResumeId: null,
      isShowDetail: false, // 預設不顯示
      detailCurrentPage: 0, // 點擊選項
      ResumeSource: null, // 履歷來源
      ResumeType: null, // 履歷種類

      // 面談紀錄歷程
      supervisorOptions: [],
      recordList: {},
      // 完成面談評估
      approveInterviewResult: {
        approvalResult: null, // 核定結果
        approvalResultRemark: null, // 備註
      },
      interviewRecordShow: 3, // 一頁顯示幾個人
      InterviewSupervisor: [], // 加簽主管列表

      // 分頁
      totalPerson: 0, // 共幾筆
      currentPage: 1, // 當前第幾頁
      stopGetNextPage: false, // 停止call API（停止取得下一頁）
    };
  },

  methods: {
    // 取得面談結果 API
    getInterviewRecordResult() {
      const vm = this;
      const api = `${window.endpoints.api}/Recruitment/InterviewRecordList/paging`;

      if (vm.totalPerson > 0) {
        if (vm.totalPerson > 30) {
          if (vm.totalPerson === vm.personList.length) {
            vm.stopGetNextPage = true;
            return;
          } else {
            vm.currentPage++;
            vm.stopGetNextPage = false;
          }
        } else {
          vm.stopGetNextPage = true;
          return;
        }
      }

      const data = {
        InterviewDateStart: this.$common.dateFormatter(
          this.searchCondition.interviewDateRange[0]
        ),
        InterviewDateEnd: this.$common.dateFormatter(
          this.searchCondition.interviewDateRange[1]
        ),
        ManpowerDemandName: this.searchCondition.ManpowerDemandName,
        Name: this.searchCondition.Name,
        IsWrote: this.searchCondition.IsWrote,
        SupervisorGuid: this.$cookies.get("userId"),
        Page: this.currentPage,
        PerPage: 30,
      };

      vm.$store.dispatch("updateLoading", true);
      vm.$http
        .post(api, data)
        .then((response) => {
          if (response.status === 200) {
            if (response.data.Quantity > 0) {
              vm.totalPerson = response.data.Quantity;
              let newArr = response.data.Datas;

              let oldArr;
              if (vm.currentPage === 1) {
                oldArr = [];
              } else {
                oldArr = vm.personList;
              }
              vm.personList = oldArr.concat(newArr);
            }

            vm.$store.dispatch("updateLoading", false);
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "查詢失敗",
            message: error.response.data,
            type: "error",
            duration: 4500,
          });
        });
    },

    // 輸入成績
    async writeScore(data) {
      this.manpowerDemandNo = data.ManpowerDemandNo;
      this.updateLoading(true);
      let person = await this.$api.interview.getScores({
        ManpowerDemandNo: this.manpowerDemandNo,
        MatchIds: [data.MatchId],
      });
      this.scoreType = person.data.map((item) => item.Scores);
      this.candidateScores = person.data;
      this.$refs.scoreModal.reset();
      this.updateLoading(false);
      $("#scoreModal").modal("show");
    },

    // 儲存成績
    saveCommonModal() {
      $("#scoreModal").modal("hide");
      this.updateLoading(true);
      this.$api.interview
        .putScores({
          ManpowerDemandNo: this.manpowerDemandNo,
          UpdateUserName: this.$cookies.get("userName"),
          Candidates: this.candidateScores.map((item) => {
            return {
              ...item,
              Scores: item.Scores.map((score) => {
                return {
                  ...score,
                  Score: score.Score === null ? null : Number(score.Score),
                };
              }),
            };
          }),
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "儲存成功",
              type: "success",
              duration: 2000,
            });
          }
          this.updateLoading(false);
        });
    },

    // 填寫面談紀錄
    createInterviewRecord(person) {
      const interviewee = {
        ResumeType: person.ResumeType,
        ResumeId: person.ResumeId,
        Name: person.Name,
        Sex: person.Sex,
        Position: person.Position,
        InterviewId: person.InterviewId,
        InterviewRecordId: person.InterviewRecordId,
      };
      localStorage.setItem("INTERVIEWEE", JSON.stringify(interviewee));
      this.$router.push({ path: "/manager/form/interviewminutes" });
    },

    // 取得 面談紀錄歷程(登入者)
    getInterviewRecordHistory(MatchId) {
      this.updateLoading(true);

      this.MatchId = MatchId;
      this.InterviewSupervisor = [];
      this.$refs.addInterviewSupervisor.reset();

      this.$api.approveInterview
        .getInterviewRecordForUser(this.MatchId)
        .then((response) => {
          if (response.status === 200) {
            this.recordList = response.data;
            let interviewSupervisorId = response.data.InterviewRecords.map(
              (element) => element.InterviewSupervisorId
            );
            this.supervisorOptions = this.supervisorOptions.filter(
              (element) => interviewSupervisorId.indexOf(element.Guid) === -1
            );
          }
          this.updateLoading(false);
          $("#interviewRecordHistoryModal").modal("show");
        });
    },

    // 加簽 API
    addInterviewRecord() {
      const vm = this;
      const api = `${window.endpoints.api}/Recruitment/AddInterviewRecord`;

      const data = {
        InterviewId: vm.recordList.InterviewId,
        InterviewSupervisor: vm.InterviewSupervisor,
        CreateUser: vm.$cookies.get("userName"),
      };

      vm.$store.dispatch("updateLoading", true);
      vm.$http.post(api, data).then((response) => {
        if (response.status === 200) {
          vm.$store.dispatch("updateLoading", false);

          vm.personList.forEach((item, index, arr) => {
            if (item.InterviewId === data.InterviewId) {
              arr[index].InterviewSupervisor = vm.InterviewSupervisor.map(
                (element) => element.Name
              );
            }
          });

          vm.$notify({
            title: "成功",
            message: "加簽成功",
            type: "success",
            duration: 2500,
          });
        }

        vm.getInterviewRecordHistory(vm.MatchId);
      });
    },

    // 檢視資訊 Modal
    showDetailModal(item) {
      this.MatchId = item.MatchId;
      this.ResumeId = item.ResumeId;
      this.ResumeType = item.ResumeType;
      this.ResumeSource = item.Source;
      this.isShowDetail = true;
    },

    async getData() {
      this.searchCondition.interviewDateRange = [
        new Date(this.$common.getLastMonth()),
        new Date(this.$common.getToday()),
      ];

      this.getInterviewRecordResult();
      const backgroundUser = await this.$api.backgroundUser.getBackgroundUser();

      // 取得主管列表
      this.supervisorOptions = backgroundUser.data.map((user) => {
        return {
          Guid: user.UserId,
          Name: user.Name,
          Email: user.Email,
        };
      });
    },

    // 日期不得大於今日
    disabledAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  computed: {
    disabled() {
      return this.stopGetNextPage;
    },

    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  watch: {
    isShowDetail: function (e) {
      if (!e) {
        this.detailCurrentPage = 0;
      }
    },
  },

  created() {
    this.getData();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-table__fixed::before {
  height: 0;
}
</style>
